import React, { useEffect } from 'react';
import { Box, Checkbox, Typography } from '@mui/material';
import { userCardStyles, UserCardActions, UserCardStatus } from './index';
import { formatCPF } from 'services/utils/format_cpf';
import { useAuth } from 'contexts/auth/auth_context';
import { canViewCPF, verifyUserUUID } from 'services/utils/permissions.uitils';

interface UserCardProps {
  userUuid: string;
  name: string;
  cpf: string;
  city: string;
  group: string;
  profile: string;
  permission: string;
  status: boolean;
  blocked: boolean;
  isChecked: boolean;
  onCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlockUser: () => void;
  onUnblockUser: () => void;
  blockDisabled: boolean;
  openManageTermDialog: () => void;
  usersWithTermValidity: boolean;
}

const UserCard: React.FC<UserCardProps> = ({
  userUuid,
  name,
  cpf,
  city,
  group,
  profile,
  permission,
  status,
  blocked,
  isChecked,
  onCheckboxChange,
  onBlockUser,
  onUnblockUser,
  blockDisabled,
  openManageTermDialog,
  usersWithTermValidity,
}) => {
  const { user } = useAuth() as any;
  const viewCPF =
    canViewCPF(user.permission.name) || verifyUserUUID(user, userUuid);
  useEffect(() => { }, [permission]);

  return (
    <Box sx={userCardStyles.container}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
          }}
        >
          <Checkbox checked={isChecked} onChange={onCheckboxChange} />
        </Box>
        <Box sx={userCardStyles.details}>
          <Typography
            sx={{
              color: '#000000DE',
              fontWeight: 500,
              fontSize: '18px',
              lineHeight: '28.26px',
              letterSpacing: '0.1px',
            }}
          >
            {name}
          </Typography>
          <Typography
            sx={{
              color: '#00000099',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '26.56px',
              letterSpacing: '0.4px',
            }}
          >{`CPF: ${formatCPF(cpf, viewCPF)}`}</Typography>
          <Typography
            sx={{
              color: '#00000099',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '26.56px',
              letterSpacing: '0.4px',
            }}
          >{`Grupo: ${group}`}</Typography>
          <Typography
            sx={{
              color: '#00000099',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '26.56px',
              letterSpacing: '0.4px',
            }}
          >{`Perfil: ${profile}`}</Typography>
          {city && (
            <Typography
              sx={{
                color: '#00000099',
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: '26.56px',
                letterSpacing: '0.4px',
              }}
            >{`Município: ${city}`}</Typography>
          )}
          <Typography
            sx={{
              color: '#00000099',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '26.56px',
              letterSpacing: '0.4px',
            }}
          >{`Permissão: ${permission}`}</Typography>
        </Box>
        <UserCardActions
          onBlockUser={onBlockUser}
          onUnblockUser={onUnblockUser}
          blockDisabled={blockDisabled}
          userUuid={userUuid}
          openManageTermDialog={openManageTermDialog}
          usersWithTermValidity={usersWithTermValidity}
          status={status}
          isBlocked={blocked}
        />
      </Box>

      <UserCardStatus status={status} blocked={blocked} />
    </Box>
  );
};

export default UserCard;